export const getUserAnnouncements = /* GraphQL */ `
  query GetUserAnnouncements(
    $tenantLandscapeLoginName: String!
    $displayStartDate: ModelIntKeyConditionInput!
    $limit: Int
    $nextToken: String
  ) {
    userAnnouncements: userAnnouncementsByDisplayStartDate(
      tenantLandscapeLoginName: $tenantLandscapeLoginName
      displayStartDate: $displayStartDate
      limit: $limit
      sortDirection: DESC
      nextToken: $nextToken
    ) {
      items {
        announcementId
        loginName
        tenant
        landscape
        tenantLandscapeLoginName
        announcement {
          title
          content
          linkToProductMenu
          isPublic
          priorityTag
        }
        displayStartDate
        displayEndDate
        isProcessed
        isRead
        isShow
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getUserAnnouncement = /* GraphQL */ `
  query GetUserAnnouncement(
    $loginName: String!
    $tenant: String!
    $landscape: String!
    $announcementId: ID!
  ) {
    userAnnouncement: getUserAnnouncement(
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
      announcementId: $announcementId
    ) {
      announcementId
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      announcement {
        title
        content
        linkToProductMenu
        isPublic
        priorityTag
      }
      displayStartDate
      displayEndDate
      isProcessed
      isRead
      isShow
      createdAt
      updatedAt
    }
  }
`;
